import {
  MetricTableType,
  useMetricsTableV2Api,
} from '@data/hooks/api/use-metrics-table-v2-api/use-metrics-table-v2-api';
import { useTeacherMetricsArgs } from '@data/hooks/use-report-tables/use-teacher-metrics-args/use-teacher-metrics-args';

/** Every skill on one page: the skills table has no pagination. */
const PAGE_SIZE = 3000;

/**
 * Every skill group and skill for the current filters, in one request. Tables
 * that call it share the one response.
 */
export function useAllClassSkills({ enabled = true } = {}) {
  const { args, ready } = useTeacherMetricsArgs();
  return useMetricsTableV2Api({
    ...args,
    metricType: MetricTableType.AllClassSkills,
    page: 1,
    pageSize: PAGE_SIZE,
    enabled: enabled && ready,
  });
}
